import '../scss/styles.scss';
import handleDate from './DatePicker';

export default function BookNow() {
    return (
        <section id="book-now" className="book-now">
            <div className="book-now-wrapper">
                <div className="book-now-text">
                    <h3>Book your event</h3>
                    <h2>Get in touch</h2>
                    <p>
                    Creating state of the art <span>Audio, Visual, and Information Technology</span> experiences is what we do. Tell us about your needs, we would love to collaborate with you. Talk with one of our experts to see how <span>Faraway Sound Productions</span> can help.
                    </p>
                </div>
                <div className="book-now-form">
                <form
                    action="https://farawaysoundproductions.us8.list-manage.com/subscribe/post?u=9e36275267d6653c68daaef66&amp;id=33b6d1ecc4&amp;f_id=00f872e0f0"
                    method="post"
                    id="mc-embedded-subscribe-form"
                    name="mc-embedded-subscribe-form"
                    className="validate"
                    target="_self">
                        <div className="book-form-half">
                            <div className="form-half">
                                <label htmlFor="mce-FNAME">First Name</label>
                                <input id="mce-FNAME" className="first-name" type="text" name="FNAME" pattern="^(\w\w+)" minLength="2" required />
                                <span className="error-msg" aria-describedby="error-for-first-name"></span>
                            </div>
                            <div className="form-half">
                                <label htmlFor="mce-LNAME">Last Name</label>
                                <input id="mce-LNAME" className="last-name" type="text" name="LNAME" />
                            </div>
                        </div>
                        <div className="book-form-full">
                            <label htmlFor="mce-COMPANY">Company Name</label>
                            <input id="mce-COMPANY" type="text" name="COMPANY" />
                        </div>
                        <div className="book-form-half">
                            <div className="form-half">
                                <label htmlFor="mce-EMAIL">Email</label>
                                <input
                                    type="email"
                                    id="mce-EMAIL"
                                    className="validate"
                                    name="EMAIL"
                                    title="The domain portion of the email address is invalid (the portion after the @)."
                                    pattern="^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*(\.\w{2,})+$"
                                    required
                                />
                                <span className="error-msg" aria-describedby="error-for-email"></span>
                            </div>
                            <div className="form-half">
                                <label htmlFor="mce-PHONE">Phone Number</label>
                                <input id="mce-PHONE" type="tel" name="PHONE" />
                            </div>
                        </div>
                        <h3>Dates of Event</h3>
                        <div className="book-form-half">
                            <div className="start-date-field">
                                <label htmlFor="MMERGE6">Start Date</label>
                                <input type="text" className="start-month" pattern="(0[1-9]|1[0-2])" placeholder="MM" size="2" minLength="2" maxLength="2" name="MMERGE6[month]" id="mce-MMERGE6-month" onInput={ handleDate } />
                                <input type="text" className="start-day" pattern="([0-2]\d|3[0-1])" placeholder="DD" size="2" minLength="2" maxLength="2" name="MMERGE6[day]" id="mce-MMERGE6-day" onInput={ handleDate } />
                                <input type="text" className="start-year" pattern="(?:19|20)[0-9]{2}" placeholder="YYYY" size="4" minLength="4" maxLength="4" name="MMERGE6[year]" id="mce-MMERGE6-year" onInput={ handleDate } />
                                <span className="cal-icon"></span>
                            </div>
                            <div className="end-date-field">
                                <label htmlFor="MMERGE7">End Date</label>
                                <input type="text" className="end-month" pattern="(0[1-9]|1[0-2])" placeholder="MM" size="2" minLength="2" maxLength="2" name="MMERGE7[month]" id="mce-MMERGE7-month" onInput={ handleDate } />
                                <input type="text" className="end-day" pattern="([0-2]\d|3[0-1])" placeholder="DD" size="2" minLength="2" maxLength="2" name="MMERGE7[day]" id="mce-MMERGE7-day" onInput={ handleDate } />
                                <input type="text" className="end-year" pattern="(?:19|20)[0-9]{2}" placeholder="YYYY" size="4" minLength="4" maxLength="4" name="MMERGE7[year]" id="mce-MMERGE7-year" onInput={ handleDate } />
                                <span className="cal-icon"></span>
                            </div>
                        </div>
                        <span className="error-msg dates" aria-describedby="error-for-start-date"></span>
                        <h3>Event & Location</h3>
                        <div className="book-form-full">
                            <label htmlFor="mce-EVENT">Type of Event</label>
                            <input id="mce-EVENT" className="type-of-event" type="text" name="EVENT" placeholder="E.g. Wedding, Corporate Meeting" required />
                            <span className="error-msg" aria-describedby="error-for-type-of-event"></span>
                        </div>
                        <div className="book-form-full">
                            <label htmlFor="mce-LOCATION">Event Location</label>
                            <input id="mce-LOCATION" className="event-location" type="text" name="LOCATION" placeholder="E.g. White Elephant Ballroom, Great Harbor Yacht Club" required />
                            <span className="error-msg" aria-describedby="error-for-event-location"></span>
                        </div>
                        <div className="book-form-full">
                            <label htmlFor="mce-DESCRIPTIO">Description</label>
                            <textarea
                                id="mce-DESCRIPTIO"
                                name="DESCRIPTIO"
                                className="description"
                                cols="40"
                                rows="10"
                                maxLength="200"
                                placeholder="Please provide a description of your event and Audio / Visual / IT requirements."
                                spellCheck="false"
                                required
                            >
                            </textarea>
                            <span className="error-msg" aria-describedby="error-for-description"></span>
                        </div>
                        <div hidden={true}><input type="hidden" name="tags" value="4889151" readOnly /></div>
                        <div style={{position: 'absolute', left: -5000}}>
                            <input type="text" name="b_9e36275267d6653c68daaef66_33b6d1ecc4" tabIndex="-1" value="" readOnly />
                        </div>
                        <button className="book-now-btn"
                            type="submit"
                            name="subscribe"
                            id="mc-embedded-subscribe"
                        >Submit</button>
                    </form>
                </div>
            </div>
        </section>
    )
}